import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromTemplates from '../reducers/templates.reducer';

export const getTemplateState = createSelector(fromFeature.getFilterState, (state: fromFeature.DashboardState) => state?.templates);

export const getTemplatesEntities = createSelector(getTemplateState, fromTemplates.getTemplatesEntities);

export const getTotalTemplates = createSelector(getTemplateState, fromTemplates.getTotalTemplates);
export const getPaginatedTemplates = createSelector(getTemplatesEntities, entities => {
  if (!entities) return [];

  return Object?.keys(entities).map(uid => entities[uid]);
});
export const getTemplatesLoaded = createSelector(getTemplateState, fromTemplates.getTemplatesLoaded);
export const getTemplatesLoading = createSelector(getTemplateState, fromTemplates.getTemplatesLoading);

/**
 * All Templates
 */
export const getAllTemplatesEntities = createSelector(getTemplateState, fromTemplates.getAllTemplatesEntities);
export const getAllTemplates = createSelector(getAllTemplatesEntities, allTemplates => allTemplates);
export const getAllTemplatesLoaded = createSelector(getTemplateState, fromTemplates.getAllTemplatesLoaded);
export const getAllTemplatesLoading = createSelector(getTemplateState, fromTemplates.getAllTemplatesLoading);

